<template>
    <div class="room dehumidifier-small" v-loading="loadingData">
        <div class="device-block-multi">
            <div class="device-block" :class="warningFlagLeft">
                <div class="device-block-line-chart">
                    <DoubleGraph :opts="humidityLineOptsLeft" :series="humidityLineDataLeft"></DoubleGraph>
                </div>
                <div class="device-block-bar-chart">
                    <SinglePieHistogramWrap :opts="humidityBarOptsLeft" :series="humidityBarDataLeft">
                    </SinglePieHistogramWrap>
                </div>
            </div>

            <div class="device-block" :class="warningFlagRight">
                <div class="device-block-line-chart">
                    <DoubleGraph :opts="humidityLineOptsRight" :series="humidityLineDataRight"></DoubleGraph>
                </div>
                <div class="device-block-bar-chart">
                    <SinglePieHistogramWrap :opts="humidityBarOptsRight" :series="humidityBarDataRight">
                    </SinglePieHistogramWrap>
                </div>
            </div>
        </div>

        <div class="device-block-multi">
            <div class="device-block-multi-item air-bg">
                <single-solid-pie :opts="singleSolidPieOptsL1" :series="singleSolidPieDataL1"></single-solid-pie>
            </div>
            <div class="device-block-multi-item air-bg">
                <single-histogram :opts="singleHisOptsL2" :series="singleHisDataL2"></single-histogram>
            </div>

            <div class="device-block-multi-item switch-time-container">
                <div class="device-block-multi-item-switch">
                    <switch-status :title="switchTitleL" :series="switchStatusDataL"></switch-status>
                </div>
                <div class="device-block-multi-item-time">
                    <RunningTimeBig :title="runningTimeTitleL" :series="runningTimeDataL"></RunningTimeBig>
                </div>
            </div>

            <div class="device-block-multi-item air-bg">
                <single-histogram :opts="singleHisOptsR2" :series="singleHisDataR2"></single-histogram>
            </div>
            <div class="device-block-multi-item air-bg">
                <single-solid-pie :opts="singleSolidPieOptsR1" :series="singleSolidPieDataR1"></single-solid-pie>
            </div>

            <!-- <div class="device-block-multi-item switch-time-container">
                <div class="device-block-multi-item-switch">
                    <switch-status :title="switchTitleR" :series="switchStatusDataR"></switch-status>
                </div>
                <div class="device-block-multi-item-time">
                    <RunningTimeBig :title="runningTimeTitleR" :series="runningTimeDataR"></RunningTimeBig>
                </div>
            </div> -->
        </div>

        <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    </div>
</template>

<script>
import configJson from "./config/airProcConfig.json";

export default {
    name: "tower",
    data() {
        return {
            timer: null,
            loading: false,
            loadingData: false,
            stationId: "",
            stationIdCommon: "",
            stationName: "",
            locationName: "",
            warningFlagLeft: "",
            warningFlagRight: "",
            deviceList: [],
            warningFlagL1: "",
            warningFlagL2: "",
            warningFlagL3: "",
            warningFlagR1: "",
            warningFlagR2: "",
            warningFlagR3: "",
            humidityLineDataLeft: null,
            humidityLineDataRight: null,
            humidityBarDataLeft: null,
            humidityBarDataRight: null,
            switchStatusDataL: null,
            switchStatusDataR: null,
            runningTimeDataL: null,
            runningTimeDataR: null,
            singleSolidPieDataL1: null,
            singleHisDataL2: null,
            singleSolidPieDataR1: null,
            singleHisDataR2: null,
        };
    },
    computed: {
        switchTitleL: function () {
            return "运行状态";
        },
        switchTitleR: function () {
            return "运行状态";
        },
        runningTimeTitleL: function () {
            return "运行时间";
        },
        runningTimeTitleR: function () {
            return "运行时间";
        },

        humidityLineOptsLeft: function () {
            return {
                title: this.stationName + "设备 上游主缆",
                legend1: "上游湿度",
                legend2: "上游温度",
            };
        },
        humidityBarOptsLeft: function () {
            return {
                title: "上游温湿度",
                histogramName1: "T",
                center1: ["52%", "60%"],
                radius1: ["40%", "55%"],
                pieName1: "RH",
                max: 50,
                pieMax: 100,
                toprichFontSize: 18,
                topFontSize: 20,
                sign: "°C",
            };
        },

        humidityLineOptsRight: function () {
            return {
                title: this.stationName + "设备 下游主缆",
                legend1: "下游湿度",
                legend2: "下游温度",
            };
        },
        humidityBarOptsRight: function () {
            return {
                title: "下游温湿度",
                histogramName1: "T",
                center1: ["52%", "60%"],
                radius1: ["40%", "55%"],
                pieName1: "RH",
                max: 50,
                pieMax: 100,
                toprichFontSize: 18,
                topFontSize: 20,
                sign: "°C",
            };
        },

        singleSolidPieOptsL1: function () {
            return { title: "上游主缆送风压力", max: 8, subTitle: "KPa" }
        },
        singleHisOptsL2: function () {
            return { title: "上游主缆送风量", max: 50, histogramName1: "m³/h" }
        },
        singleSolidPieOptsR1: function () {
            return { title: "下游主缆送风压力", max: 8, subTitle: "KPa" }
        },
        singleHisOptsR2: function () {
            return { title: "下游主缆送风量", max: 50, histogramName1: "m³/h" }
        },
    },
    created() {
        this.readConfig();
    },
    mounted() {
        this.loadingData = true;
        this.getData();
        this.timer = setInterval(() => {
            this.getData();
        }, this.REFRESH_SECOND);
    },
    watch: {
        /**
         * 监听路由变化
         * @param {Object} route # 当前路由信息
         */
        $route(route) {
            this.resetData();
            this.readConfig();
            this.loadingData = true;
            this.getData();
        },
    },
    methods: {
        resetData() {
            this.warningFlagLeft = "";
            this.warningFlagRight = "";
            this.warningFlagL1 = "";
            this.warningFlagL2 = "";
            this.warningFlagL3 = "";
            this.warningFlagR1 = "";
            this.warningFlagR2 = "";
            this.warningFlagR3 = "";
        },
        refreshData() {
            this.loadingData = true;
            this.getData();
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                this.getData();
            }, this.REFRESH_SECOND);
        },
        readConfig() {
            const routerPath = this.$route.fullPath.split("/");
            const routerName = routerPath[2].toLowerCase();
            this.deviceList = configJson[routerName].deviceList;
            this.stationName = configJson[routerName].stationName;
            this.stationId = configJson[routerName].stationId;
            this.stationIdCommon = configJson[routerName].stationIdCommon;
            this.locationName = configJson[routerName].location;
        },
        findDeviceId(deviceName) {
            const device = this.deviceList.find((el) => {
                return el.deviceName === deviceName;
            });
            if (!device) {
                console.log(`deviceName${deviceName}###`);
            }
            return device.deviceId || "";
        },
        getStatisticsData(deviceId) {
            return this.$http.get("/statistics/DeviceData?deviceId=" + deviceId + "&interval=BY_HOUR&insertBlankData=true");
        },
        getCurrentData(stationId) {
            return this.$http.get("/deviceData/Station?stationId=" + stationId);
        },
        getData() {
            this.getLineChartData();

            this.$http.all([this.getCurrentData(this.stationId), this.getCurrentData(this.stationIdCommon)]).then(
                this.$http.spread((stationRes, commonRes) => {
                    setTimeout(() => {
                        this.loadingData = false;
                    }, 500);

                    const currentData = { ...stationRes.data, ...commonRes.data };

                    this.setPieHistogramDataAndError(currentData, "humidityBarDataLeft", this.locationName + "上游主缆送风温度"
                        , this.locationName + "上游主缆送风湿度", "warningFlagLeft");
                    this.setPieHistogramDataAndError(currentData, "humidityBarDataRight", this.locationName + "下游主缆送风温度"
                        , this.locationName + "下游主缆送风湿度", "warningFlagRight");


                    this.setSingleSolidPieDataAndError(currentData, "singleSolidPieDataL1", this.locationName + "上游主缆送风压力", "warningFlagL1");
                    this.setSingleSolidPieDataAndError(currentData, "singleHisDataL2", this.locationName + "上游主缆送风量", "warningFlagL2");
                    this.setSingleSolidPieDataAndError(currentData, "singleSolidPieDataR1", this.locationName + "下游主缆送风压力", "warningFlagR1");
                    this.setSingleSolidPieDataAndError(currentData, "singleHisDataR2", this.locationName + "下游主缆送风量", "warningFlagR2");

                    const switchIdL = this.findDeviceId("空气处理设备" + this.switchTitleL);
                    const switchIdR = this.findDeviceId("空气处理设备" + this.switchTitleR);
                    this.switchStatusDataL = {
                        data: currentData[switchIdL].value,
                        isError: currentData[switchIdL].errorLevel,
                    };
                    this.switchStatusDataR = {
                        data: currentData[switchIdR].value,
                        isError: currentData[switchIdR].errorLevel,
                    };

                    const runningTimeIdL = this.findDeviceId("空气处理设备累计" + this.runningTimeTitleL);
                    this.runningTimeDataL = currentData[runningTimeIdL].value;

                    const runningTimeIdR = this.findDeviceId("空气处理设备累计" + this.runningTimeTitleR);
                    this.runningTimeDataR = currentData[runningTimeIdR].value;
                })
            )

        },
        setSingleSolidPieDataAndError(currentData, echartSeriesDataName, deviceName, warningFlagName) {
            const deviceId = this.findDeviceId(deviceName);
            this[echartSeriesDataName] = {
                data1: currentData[deviceId].value,
            };

            let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[deviceId].errorLevel, this[warningFlagName]);
            this[warningFlagName] = errorLevel;
        },
        setPieHistogramDataAndError(currentData, echartSeriesDataName, temperatureName, humidityName, warningFlagName) {
            const temperatureId = this.findDeviceId(temperatureName);
            const humidityId = this.findDeviceId(humidityName);
            this[echartSeriesDataName] = {
                data1: currentData[temperatureId].value,
                data2: currentData[humidityId].value,
            };

            let errorLevel = this.getErrorLevelFromMultipleDevice(currentData[temperatureId].errorLevel, this[warningFlagName]);
            errorLevel = this.getErrorLevelFromMultipleDevice(currentData[humidityId].errorLevel, this[warningFlagName]);
            this[warningFlagName] = errorLevel;
        },
        getLineChartData() {
            let temperatureDeviceNameLeft = this.locationName + "上游主缆送风温度";
            let humidityDeviceNameLeft = this.locationName + "上游主缆送风湿度";
            this.$http
                .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceNameLeft)), this.getStatisticsData(this.findDeviceId(humidityDeviceNameLeft))])
                .then(
                    this.$http.spread((temperaturePromise, humidityPromise) => {
                        this.setLineData(temperaturePromise, humidityPromise, "humidityLineDataLeft", "warningFlagLeft");
                    })
                );

            let temperatureDeviceNameRight = this.locationName + "下游主缆送风温度";
            let humidityDeviceNameRight = this.locationName + "下游主缆送风湿度";
            this.$http
                .all([this.getStatisticsData(this.findDeviceId(temperatureDeviceNameRight)), this.getStatisticsData(this.findDeviceId(humidityDeviceNameRight))])
                .then(
                    this.$http.spread((temperaturePromise, humidityPromise) => {
                        this.setLineData(temperaturePromise, humidityPromise, "humidityLineDataRight", "warningFlagRight ");
                    })
                );
        },
        setLineData(temperatureData, humidityData, echartSeriesDataName, warningFlagName) {
            let data1 = {};
            let data2 = {};
            temperatureData.data.dataList.forEach((item, index) => {
                data1[item.StatisticsDate] = item.value;
            });
            humidityData.data.dataList.forEach((item, index) => {
                data2[item.StatisticsDate] = item.value;
            });

            this[echartSeriesDataName] = {
                data1: data1,
                data2: data2,
            };

            let errorLevel = this.getErrorLevelFromMultipleDevice(temperatureData.data.errorLevel, this[warningFlagName]);
            errorLevel = this.getErrorLevelFromMultipleDevice(humidityData.data.errorLevel, this[warningFlagName]);
            this[warningFlagName] = errorLevel;
        },
        getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
            if (currentErrorLevel === "Error") {
                return "Error";
            } else if (currentErrorLevel === "Warning") {
                if (newErrorLevel === "Error") {
                    return "Error";
                } else {
                    return "Warning";
                }
            } else {
                return newErrorLevel;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.dehumidifier-small {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: stretch;
    align-content: stretch;
    padding-top: 10px;

    .device-block-multi {
        width: 100%;
        height: calc(50% - 15px);
        background-color: transparent;
        display: flex;
        justify-content: space-between;
        align-items: stretch;

        .device-block {
            width: calc(50% - 10px);
            height: 100%;
            display: flex;
            justify-content: space-between;
            align-items: stretch;
            position: relative;

            .device-block-line-chart {
                width: 75%;
                height: 100%;
            }

            .device-block-bar-chart {
                width: 24%;
                height: 100%;
            }
        }

        .device-block-multi-item {
            background-color: rgba(255, 255, 255, 0.6);
            width: calc((100% / 5) - 10px);
        }

        .switch-time-container {
            display: flex;
            height: 100%;
            flex-direction: column;
            background-color: transparent;
        }

        .device-block-multi-item-switch {
            height: 60px;
        }

        .device-block-multi-item-time {
            flex: 1;
        }

        .device-block-line-item {
            width: calc(50% - 10px);
            display: flex;
            box-sizing: border-box;
            justify-content: space-between;
            align-items: stretch;

            .device-block-line-item-top {
                display: flex;
                justify-content: space-between;
                height: 140px;
                width: 100%;
            }

            .device-block-line-item-half {
                display: flex;
                height: 100%;
                width: calc(50% - 7px);
                flex-direction: column;
                justify-content: space-between;
            }

            .switch-item {
                height: 38px;
                width: 100%;
                box-sizing: border-box;
                margin-bottom: 10px;
                flex-shrink: 0;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            .device-block-time-left {
                height: calc(100% - 190px);
                width: 100%;
                box-sizing: border-box;
            }

            .device-block-time-right {
                height: calc(100% - 140px);
                width: 100%;
                box-sizing: border-box;
            }
        }
    }

    .device-block-line {
        width: 100%;
        height: calc(50% - 15px);
        background-color: transparent;
        display: flex;
        justify-content: space-between;
        align-items: stretch;

        .device-block-line-item {
            width: calc(50% - 10px);
            display: flex;
            box-sizing: border-box;
            justify-content: space-between;
            flex-direction: column;
            align-items: stretch;

            .device-block-line-item-top {
                display: flex;
                justify-content: space-between;
                height: 140px;
                width: 100%;
            }

            .device-block-line-item-half {
                display: flex;
                height: 100%;
                width: calc(50% - 7px);
                flex-direction: column;
                justify-content: space-between;
            }
        }
    }
}
</style>
